<template>
  <div :class="styles">
    <img v-if="image" class="risk-icon__image" :src="source" :alt="description" />
    <i v-else class="risk-icon__icon"><span class="sr-only">{{ description }}</span></i>
  </div>
</template>

<script>
  import constants from '../../constants';

  export default {
    props: {
      rating: {
        type: Number,
        required: true,
      },
      image: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      styles() {
        return {
          'risk-icon': true,
          [`risk-icon--danger-${this.zeroBasedRating()}`]: true,
          'risk-icon--image': this.image,
          'risk-icon--icon': !this.image,
        };
      },

      description() {
        return constants.DANGER_RATINGS[this.rating];
      },

      source() {
        return `/resources/themes/default/images/danger-scale-${this.zeroBasedRating()}.png`;
      },
    },

    methods: {
      /**
       * Makes all ratings less than zero (spring conditions etc) equal zero.
       *
       * @return {Number}
       */
      zeroBasedRating() {
        const rating = parseInt(this.rating, 10);
        return rating < 1 ? 0 : rating;
      },
    },
  };
</script>
